const contentManagement = {
  title: 'Outreach',
  desc: 'Manage content templates and mailbox settings from one place for outreach and communication workflows.',
  moduleLabel: 'Settings',
  contentModuleLabel: 'Templates',
  accountModuleLabel: 'Account',
  descChat:
    'Saved note templates for LinkedIn Messaging dialogues - improve communication efficiency',
  descGreeting: 'Connection note templates for LinkedIn requests from the EasyHire AI dashboard.',
  descInmail:
    'InMail messages for LinkedIn outreach workflows - improve enterprise batch communication efficiency',
  descTemplate:
    'Email messages for outreach from EasyHire AI dashboard - improve communication efficiency',
  tabChat: 'Saved Notes',
  tabGreeting: 'Connection Note',
  tabInmail: 'InMail Message',
  tabTemplate: 'Email Message',
  chat: 'Saved Notes',
  greeting: 'Connection Note',
  inmail: 'InMail Message',
  template: 'Email Message',
  editPhrase: 'Edit common phrase',
  editPhraseDesc: 'Edit the {type} here and save to update the list immediately.',
  editingBadge: 'Editing',
  addPhrase: 'Add',
  addPhraseTitle: 'Add common phrase',
  addGreetingPhraseTitle: 'Add connection note',
  addInmailPhraseTitle: 'Add InMail message',
  addPhraseDesc:
    'New items appear in the list immediately and can still be edited or deleted later.',
  phraseTitle: 'Note',
  phraseTitlePlaceholder: 'Enter note',
  phraseContent: 'Content',
  phraseContentPlaceholder: 'Enter content',
  phraseCount: '{count} items',
  refresh: 'Refresh',
  phraseLabel: 'Note:',
  contentLabel: 'Content:',
  unnamedTitle: 'No note',
  edit: 'Edit',
  delete: 'Delete',
  loadingTitle: 'Loading {type}',
  templateLoadingTitle: 'Loading email messages',
  loadingDesc: 'Please wait, content is on its way.',
  emptyTitle: 'No {type} yet',
  emptyDesc:
    'Use the samples below as a starting point, then click Add in the top right to create your own.',
  emptyExampleBadge: 'Sample Templates',
  sceneButton: 'Usage Example',
  sceneBadge: 'Use Case',
  chatSceneTitle: 'LinkedIn Messaging usage scene',
  chatSceneDesc: 'These saved notes appear in the LinkedIn Messaging dialog. Entry link:',
  greetingSceneTitle: 'Connection note usage',
  greetingSceneDesc: 'These notes appear in the connection request dialog under "Use Template".',
  emptyChatNotePrimary: 'Icebreaker',
  emptyChatContentPrimary:
    "Hi {'{name}'}, I would love to briefly connect about what our team is building.",
  emptyChatNoteSecondary: 'Follow-up',
  emptyChatContentSecondary:
    'Just checking whether you might have 10 minutes this week to hear about the opportunity. I can send the JD first if helpful.',
  emptyGreetingNotePrimary: 'Quick intro',
  emptyGreetingContentPrimary:
    "Hi {'{name}'}, your experience looks highly relevant to a role we are hiring for. Happy to connect and share more.",
  emptyGreetingNoteSecondary: 'Industry fit',
  emptyGreetingContentSecondary:
    "Hi {'{name}'}, your professional background stood out. Would you be open to connecting?",
  emptyInmailNotePrimary: 'Role outreach',
  emptyInmailContentPrimary:
    "Hi {'{{name}}'}, your work at {'{{company}}'} looks relevant to a {'{{role}}'} role we are hiring for. I would like to briefly share the opportunity.",
  emptyInmailNoteSecondary: 'High-potential profile',
  emptyInmailContentSecondary:
    "Hi {'{{name}}'}, your {'{{industry}}'} background fits an area we are focused on. If you are open, I can send the role details.",
  emptyTemplateDesc:
    'Use this sample email structure as a starting point, then click New Template in the top right to create your own.',
  emptyTemplateName: 'Job Outreach Template',
  emptyTemplateSubject: "A quick intro about an opportunity at {'{{company}}'}",
  emptyTemplateSnippet:
    "Hi {'{{name}}'},\n\nYour experience at {'{{company}}'} looks highly relevant to an open {'{{role}}'} opportunity on our team.\n\nIf you are open to it, I would love to schedule a quick 10-minute intro this week, or I can send the JD first.\n\nBest regards,\n{'{{name}}'}",
  emptyTemplateFooter: 'Your latest saved template will appear here',
  templateList: 'Templates',
  newTemplate: 'New Template',
  noTemplate: 'No email messages yet',
  templateName: 'Template Name',
  templateNamePlaceholder: 'e.g. Job Invitation Template',
  emailSubject: 'Email Subject',
  emailSubjectPlaceholder: 'Enter email subject',
  htmlBody: 'Email Body',
  templateEditorDesc:
    'The API only needs a template name, email subject, and email body for sending.',
  templateChannel: 'Email',
  updatedAt: 'Updated',
  deleteCurrentTemplate: 'Delete Current Template',
  cancel: 'Cancel',
  emailPreview: 'Email Preview',
  placeholderLabel: 'Placeholders:',
  placeholderExample: "eg: Hello {'{{name}}'} = Hello Clement Hu",
  updateTemplate: 'Update Template',
  saveTemplate: 'Save Template',
  previewTitle: 'Email Preview',
  noSubject: 'No subject entered',
  noContent: 'No content',
  titleRequired: 'Note is required',
  contentRequired: 'Content is required',
  contentTooLong: 'Content cannot exceed {count} characters',
  loadFailed: 'Load failed',
  saveSuccess: 'Saved successfully',
  saveFailed: 'Save failed',
  deleteConfirm: 'This action cannot be undone. Are you sure?',
  deletePhraseTitle: 'Delete common phrase',
  deleted: 'Deleted',
  deleteFailed: 'Delete failed',
  templateFieldsRequired: 'Template name, subject and body cannot be empty',
  templateUpdateSuccess: 'Template updated successfully',
  templateCreateSuccess: 'Template created successfully',
  deleteTemplateConfirm: 'This action cannot be undone. Are you sure?',
  deleteTemplateTitle: 'Delete Email Message',
  templateDeleted: 'Email message deleted',
}

export default contentManagement
